import React from "react";
import Breadcrumb from "../Breadcrumb";
import { useBreadcrumb } from "../Breadcrumb/BreadcrumbContext";
import styles from "./subheader.module.css";

interface SubHeaderProps {
  isSubSidebarCollapsed: boolean;
}

const SubHeader: React.FC<SubHeaderProps> = ({ isSubSidebarCollapsed }) => {
  const { breadCrumbItems } = useBreadcrumb();
  return (
    <nav>
      <div className={styles.subHeaderBar}>
        <Breadcrumb
          items={breadCrumbItems}
          customStyles={{
            marginLeft: isSubSidebarCollapsed ? "96px" : "260px",
          }}
        />
      </div>
    </nav>
  );
};

export default SubHeader;
